import type { DrawerProps } from "antd";
import { Drawer } from "antd";
import styled from "styled-components";

interface StyledDrawerProps extends DrawerProps {
    $withoutBorder?: boolean;
}

const DrawerWrapper = (props: StyledDrawerProps) => <Drawer {...props} />;

export const StyledDrawer = styled(DrawerWrapper)`
    ${({ $withoutBorder }) =>
        $withoutBorder &&
        `
            .ant-drawer-body {
                .ant-collapse {
                    border: none;
                }
            }
        `}
`;
